import ExpandableDesc from '@cohort/components-xps/components/ExpandableDesc';
import PerkCardSingleInstance from '@cohort/wallet/components/card/PerkCardSingleInstance';
import PerksGrid from '@cohort/wallet/components/layout/PerksGrid';
import SectionTitle from '@cohort/wallet/components/SectionTitle';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import SpaceContentDivider from '@cohort/wallet/layouts/space/SpaceContentDivider';
import SpacePage from '@cohort/wallet/layouts/space/SpacePage';
import AboutDigitalAssetPanel from '@cohort/wallet/pages/space/AboutDigitalAssetPanel';
import type {OwnershipWDto} from '@cohort/wallet-schemas/ownership';
import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

interface DigitalAssetDetailPageDesktopProps {
  ownership: OwnershipWDto;
}

const DigitalAssetDetailPageDesktop: React.FC<DigitalAssetDetailPageDesktopProps> = ({
  ownership,
}) => {
  const {space} = useSpaceContext();
  const {hasDarkBg, backgroundColor} = useThemeContext();
  const {t} = useTranslation('pages', {keyPrefix: 'space.digitalAssetDetailPage'});

  if (space === undefined) {
    return <Fragment />;
  }

  return (
    <SpacePage
      title={`${ownership.digitalAsset.collection.title} #${ownership.digitalAsset.tokenId}`}
      tracking={{
        namespace: 'digitalAssets.detail',
        metadata: {
          ownershipId: ownership.id,
        },
      }}
      leftPanel={<AboutDigitalAssetPanel ownership={ownership} />}
    >
      <div className="flex flex-col justify-between">
        <div>
          <div className="relative">
            <SectionTitle content={t('sectionDescription')} />

            <ExpandableDesc
              hasDarkBg={hasDarkBg}
              backgroundColor={backgroundColor}
              description={ownership.digitalAsset.collection.description}
            />
          </div>

          <SpaceContentDivider />

          <div data-testid="perks" className="relative">
            <SectionTitle content={t('sectionPerks')} />

            <PerksGrid>
              {ownership.digitalAsset.perkAccesses.map(perkAccess => (
                <PerkCardSingleInstance
                  key={perkAccess.id}
                  ownership={ownership}
                  perkAccess={perkAccess}
                />
              ))}
            </PerksGrid>
          </div>
        </div>
      </div>
    </SpacePage>
  );
};

export default DigitalAssetDetailPageDesktop;
